<template>
  <div id="container" v-if="fetch_data">
    <section id="atusatus-entry">
      <div class="wrap">
        <div class="cts_box">
          <h1 class="main_ttl"><span>{{ fetch_data.title }}</span></h1>

          <div class="body_tbl">
            <h3 class="min_ttl"><span>エントリー完了</span></h3>
            <p class="lead_txt">エントリーを受け付けました。お申し込みありがとうございました。</p>
          </div>
        </div>

        <div class="cts_box">
          <div class="button_wrap">
            <router-link to="/" class="submit basic arrow">トップページにもどる</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
    return {
      fetch_data: null,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/last_contest.json`)
          .then(response => {
            this.fetch_data = response.data
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
  }
}
</script>
